<template>
  <div class="message-body" :class="[senderType == 'user' ? 'color-theme-default' : '']">
    <video
      :src="video.url | absURL"
      width="100%"
      height=""
      :poster="video.thumbnail_url | absURL"
      controls="controls"
      preload="metadata"
      onclick="this.play()">
    </video>
  </div>
</template>

<script>
export default {
  props: ['video', 'senderType']
}
</script>
